import CalendarBlock from './CalendarBlock.vue';

export * from './consts';
export default CalendarBlock;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/calendar/components/calendar/index.ts